// extracted by mini-css-extract-plugin
module.exports = {"paymentExample__hired":"PaymentExample_paymentExample__hired__EEtn3","paymentExample__result":"PaymentExample_paymentExample__result__QXd_1"};